


















import { defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationFullCreatorApplicationDeclined",
  components: { BaseIcon, BaseButton, NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
});
